import SaveResourcesSearchForm from './SaveResourcesSearchForm';

export default SaveResourcesSearchForm;
